import React from 'react'
import Content from './Content'

import { Container,Typography } from '@material-ui/core'

class Page401 extends React.Component {
    render() {
        return <Content>
            <Container style={{textAlign:"center",marginTop:"10%"}}>
                <Typography component="h1" variant="h1">401</Typography>
                <Typography component="h2" variant="overline">Not authorized</Typography>
                <Typography component="p" variant="caption">Access is denied due to invalid credentials</Typography>
            </Container>
        </Content>
    }
}

export default Page401